import React, { Component, Fragment } from 'react';
import '../../../config/cssDTB/buttonsDTB.css';
import { Link } from 'react-router-dom';
import ConfDtb from '../../../config/confDtb';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { dataProdi } from '../../../dummy-data/prodi';
import { dropdownAngkatan, dataMahasiswa } from '../../../dummy-data/mahasiswa';

const $ = require("jquery");
$.Datatable = require("datatables.net");

class StatusMahasiswa extends Component {

    state = {
        listMahasiswa: [],
        listProdi: [],
        listAngkatan: [],
        listJalur: [],
        formdata: {
            idjurusan: "",
            idjalur: "",
            idangkatan: ""
        }
    }

    // handle untuk perubahan value input by name
    HandleChange = (e) => {
        this.setState({
            formdata: {
                ...this.state.formdata,
                [e.target.name]: e.target.value
            }
        })
    };
    getFilter = () => {
        this.setState({
            listAngkatan: dropdownAngkatan.map(a => ({ id_angkatan: a.value, angkatan: a.label })),
            listProdi: dataProdi.map(p => ({ id_jurusan: p.prodi_id, nama_jurusan: p.prodi_nama }))
        });
    }

    handleView = (e) => {
        e.preventDefault();
        this.setState({ isLoad: true })
        $('#tabel').DataTable().destroy();

        // Filter mahasiswa using dummy data
        let filtered = [...dataMahasiswa];

        if (this.state.formdata.idjurusan) {
            filtered = filtered.filter(m => m.prodi_id === parseInt(this.state.formdata.idjurusan));
        }
        if (this.state.formdata.idangkatan) {
            filtered = filtered.filter(m => m.angkatan === parseInt(this.state.formdata.idangkatan));
        }

        const mappedData = filtered.map(m => ({
            idcamaba: m.mhs_id,
            nim: m.nim,
            nama: m.nama,
            koderpl: '-',
            kategorikelas: 'Pagi',
            keterangan: m.status
        }));

        setTimeout(() => {
            this.setState({
                listMahasiswa: mappedData,
                idjurusan: this.state.formdata.idjurusan,
                idangkatan: this.state.formdata.idangkatan,
                idjalur: this.state.formdata.idjalur,
                isLoad: false
            }, () => { ConfDtb() });
        }, 300);
    }

    cetakAll = () => {
        document.getElementById("excelAll").click();
    }


    componentDidMount = () => {
        this.getFilter()
        ConfDtb();
    }

    render() {
        return (
            <Fragment>

                <div className="col-md-12 mb-3">
                    <div className="row">
                        <div className="col-12 col-xl-8 mb-xl-0">
                            <p className="abu" style={{
                                fontSize: '15px', fontWeight: 'bold', color: '#999999',
                                textTransform: 'capitalize'
                            }}>
                                Mahasiswa&nbsp;&nbsp;&rsaquo;&nbsp;&nbsp;Status Mahasiswa
                            </p>
                        </div>
                    </div>
                </div>

                <div className="row" id="smoothMain">
                    <div className="col-xl-12">
                        <div className="card card-custom mb-3 pr-3 pl-3">
                            <div className="card-body">
                                <form onSubmit={this.handleView}>
                                    <div className="row">
                                        <div className="col-md-3 mt-2 mb-2">
                                            <label style={{ fontSize: '14px' }}>Program studi :</label>
                                            <select className="form-control selectCust"
                                                id="prodi"
                                                name="idjurusan"
                                                onChange={this.HandleChange}
                                                required
                                            >
                                                <option value="prodi">- Program Studi -</option>
                                                {
                                                    this.state.listProdi.map((list, i) => {
                                                        return (
                                                            <option key={i} value={list.id_jurusan}>{list.nama_jurusan}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                        <div className="col-md-3 mt-2 mb-2">
                                            <label style={{ fontSize: '14px' }}>Tahun angkatan :</label>
                                            <select className="form-control selectCust"
                                                id="angkatan"
                                                name="idangkatan"
                                                onChange={this.HandleChange}
                                                required
                                            >
                                                <option value="" hidden>- Angkatan -</option>
                                                {this.state.listAngkatan.map((list, i) => {
                                                    return (
                                                        <option key={i} value={list.id_angkatan}>{list.angkatan}</option>
                                                    )
                                                })}
                                            </select>
                                        </div>
                                        <div className="col-md-3 mt-2 mb-2">
                                            <label style={{ fontSize: '14px' }}>Jalur :</label>
                                            <select id="jalur" className="form-control selectCust"
                                                name="idjalur"
                                                onChange={this.HandleChange}
                                            >
                                                <option value="">- pilih -</option>
                                                <option value="1"> Regular </option>
                                                <option value="2"> Malam </option>

                                            </select>
                                        </div>
                                        <div className="col-md-3 mt-2 mb-2">
                                            <p align="right">
                                                <button
                                                    id="btn-cari"
                                                    className="btn btn-success btn-md"
                                                    style={{ borderRadius: '5px', marginTop: '28.5px' }}
                                                    type="submit"
                                                >
                                                    cari
                                                </button>
                                            </p>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="card card-custom">
                            <div className="card-body">
                                <p className="card-title text-center mb-3" style={{ fontSize: '25px', marginTop: '10px' }}>Status Mahasiswa</p>

                                <div id="loader" style={{ display: 'none', marginTop: '80px' }}>
                                    <div id="spinner" className="loader-1 colorful mt-5 mb-5">
                                        <div className="dot" />
                                        <div className="dot" />
                                        <div className="dot" />
                                    </div>
                                </div>

                                <div id="kontenTabel">
                                    <div className="table-responsive">
                                        <table id="tabel" className="display expandable-table table-striped" style={{ width: '100%' }}>
                                            <thead>
                                                <tr>
                                                    <th>No</th>
                                                    <th>NIM</th>
                                                    <th>Nama Mahasiswa</th>
                                                    <th>RPL</th>
                                                    <th>Kelas</th>
                                                    <th>Keterangan</th>
                                                    <th>Aksi</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.listMahasiswa.map((list, i) => {
                                                        return (
                                                            <tr key={i}>
                                                                <td>{i + 1}</td>
                                                                <td>{list.nim}</td>
                                                                <td>{list.nama}</td>
                                                                <td>{list.koderpl}</td>
                                                                <td><span class="badge bg-primary">{list.kategorikelas}</span></td>
                                                                <td><span class="badge bg-success">{list.keterangan}</span></td>
                                                                <td>
                                                                    <Link
                                                                        target={"_blank"}
                                                                        type="button"
                                                                        className="btn btn-primary ml-2 mt-1"
                                                                        to={`data-mahasiswa/biodata?id=${list.idcamaba}&nim=${list.nim}`}
                                                                        style={{ padding: "10px 15px 10px 15px", borderRadius: '5px' }}
                                                                        onClick={() => {
                                                                            localStorage.setItem('grub_id', this.props.grub_id);
                                                                        }}
                                                                    >
                                                                        detail
                                                                    </Link>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                        <br />
                                        <p align="right">
                                            <button className="btn btn-primary" onClick={this.cetakAll}>
                                                <i className="fa fa-print" />
                                                &nbsp; Cetak
                                            </button>
                                            <ReactHTMLTableToExcel
                                                id="excelAll"
                                                className="btn btn-primary sembunyi"
                                                table="table2"
                                                filename={`excel-cek-status-mahasiswa`}
                                                sheet="tablexls"
                                                buttonText="Cetak" />
                                        </p>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    {/* cetak excel all */}
                    <table id="table2" border='1' style={{ display: 'none' }}>
                        <center><h2>Data Status</h2> <br /></center>
                        <thead>
                            <tr>
                                <th>No</th>
                                <th>NIM</th>
                                <th>Nama Mahasiswa</th>
                                <th>RPL</th>
                                <th>Kelas</th>
                                <th>Keterangan</th>
                            </tr>
                        </thead>
                        <tbody id="data-table">
                            {
                                this.state.listMahasiswa.map((list, i) => {
                                    return (
                                        <tr key={i}>
                                            <td>{i + 1}</td>
                                            <td>{list.nim}</td>
                                            <td>{list.nama}</td>
                                            <td>{list.koderpl}</td>
                                            <td>{list.kategorikelas}</td>
                                            <td>{list.keterangan}</td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                    {/* cetak excel all */}

                </div>
            </Fragment>
        )
    }
}

export default StatusMahasiswa